import { render, staticRenderFns } from "./OpenGraph.vue?vue&type=template&id=4d474a04&"
import script from "./OpenGraph.vue?vue&type=script&lang=js&"
export * from "./OpenGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports